// Imports
import React, { useEffect } from 'react';
import { useRouteError } from 'react-router-dom';
import * as Sentry from '@sentry/browser';
import UnexpectedError from '../unexpected-error';


// Function component
const RouteErrorBoundary: React.FC = () => {
	// Use React Router functionality
	const error = useRouteError();
	
	
	// Report error to Sentry
	useEffect(() => {
		if (error instanceof Response) {
			return;
		}
		
		Sentry.captureException(error);
	}, [error]);
	
	
	// Return JSX
	return <UnexpectedError />;
};

export default RouteErrorBoundary;
